import React from 'react';
import './MultiUnitTitle.less';

export default function MultiUnitTitle(props) {
    const {headline} = props;
    return <h3 className="MultiUnitDropdown__title"> {headline}</h3>;
}
